export default {
  preset: 'Preset',
  presets: 'Presets',
  clear: 'Clear filter',

  isActive: {
    true: 'Only active',
    false: 'Only not active'
  }
}
